import GrowthContentComponent from '../Components/Growth/GrowthContentComponent';

function GrowthContentPage() {
  return <GrowthContentComponent />;
}

export default GrowthContentPage;